import comp from "./CarouselCards";
export default comp;
